export function formatYen(n: number): string {
  // Defensive: API can technically return 0 or negative when the model
  // extrapolates wildly (very low-data rural clicks). Display "—" instead
  // of "0円" or "-1円" so the result block stays meaningful.
  if (n == null || !isFinite(n) || n <= 0) return '—';
  if (n >= 100_000_000) return `${(n / 100_000_000).toFixed(2)}億円`;
  if (n >= 10_000) return `${(n / 10_000).toFixed(0)}万円`;
  return `${n.toLocaleString()}円`;
}

/** 1 坪 in ㎡. The unit sellers and agents actually quote in. */
export const SQM_PER_TSUBO = 3.305785;

/**
 * Same rounding as formatYen, but with the digits and the unit returned
 * separately so they can be typeset differently — the figures are set in the
 * narrow lining face and the 万円 / 億円 in mincho at a smaller size, which
 * is how a price is written on a Japanese property sheet.
 */
export function splitYen(n: number): { value: string; unit: string } {
  if (n == null || !isFinite(n) || n <= 0) return { value: '—', unit: '' };
  if (n >= 100_000_000) return { value: (n / 100_000_000).toFixed(2), unit: '億円' };
  if (n >= 10_000) return { value: Math.round(n / 10_000).toLocaleString(), unit: '万円' };
  return { value: Math.round(n).toLocaleString(), unit: '円' };
}

/** Yen → 万円, comma-grouped, no unit. For axis ticks and dense tables. */
export function formatMan(n: number): string {
  if (n == null || !isFinite(n) || n <= 0) return '—';
  return Math.round(n / 10_000).toLocaleString();
}

/** 円/㎡ → 万円/㎡ with one decimal, which is the resolution people quote. */
export function formatManPerSqm(yenPerSqm: number): string {
  if (!isFinite(yenPerSqm) || yenPerSqm <= 0) return '—';
  return (yenPerSqm / 10_000).toFixed(1);
}
